'use client'

import { Capacitor, registerPlugin } from '@capacitor/core'
import { createNativeIdTokenNonce, type NativeIdTokenNonce } from '@/lib/native-id-token-nonce'

export interface NativeGoogleAuthPlugin {
  signIn: (input?: { nonce?: string }) => Promise<{ idToken: string }>
}

export const NativeGoogleAuth = registerPlugin<NativeGoogleAuthPlugin>('NativeGoogleAuth')

export function isNativeGoogleAuthAvailable(): boolean {
  if (typeof window === 'undefined') return false

  return Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('NativeGoogleAuth')
}

export function useNativeGoogleAuthAvailability(isNativeApp: boolean): boolean {
  return isNativeApp && isNativeGoogleAuthAvailable()
}

export function useGoogleSignInNativeBlocker(isNativeApp: boolean): boolean {
  const nativeGoogleAuthAvailable = useNativeGoogleAuthAvailability(isNativeApp)

  return isNativeApp && !nativeGoogleAuthAvailable
}

export type GoogleIdTokenNonce = NativeIdTokenNonce

export async function createGoogleIdTokenNonce(): Promise<GoogleIdTokenNonce> {
  return createNativeIdTokenNonce()
}

export async function signInWithNativeGoogle(input?: { nonce?: string }): Promise<{ idToken: string }> {
  return NativeGoogleAuth.signIn(input)
}
